// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","766":"component---src-pages-sluzby-js","929":"component---src-pages-kontakt-js"}[chunkId] + "-" + {"223":"896bdf878b299d248083","293":"dd5026e11d4c472f941e","766":"b3b157bbd933988c526e","929":"c0961a91da9e0ca62282"}[chunkId] + ".js";
};